var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58841 0H24.4116C28.6027 0 32 3.39732 32 7.5884V24.4116C32 28.6027 28.6027 32 24.4116 32H7.58841C3.39733 32 0 28.6027 0 24.4116V7.5884C0 3.39732 3.39733 0 7.58841 0Z",
    fill: "#3D599C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0124 6.10468L18.0953 6.03986C16.9477 6.01803 15.8404 6.44666 15.0109 7.25762C14.1814 8.06858 13.7249 9.15406 13.7249 10.3143V13.0812H11.0142C10.9024 13.0812 10.8125 13.1712 10.8125 13.283V16.7603C10.8125 16.8714 10.9024 16.9621 11.0142 16.9621H13.7249V25.7596C13.7249 25.8714 13.8149 25.9614 13.9267 25.9614H17.5165C17.6283 25.9614 17.7183 25.8714 17.7183 25.7596V16.9621H20.4515C20.5527 16.9621 20.6387 16.8867 20.6519 16.7861L21.1037 13.3094C21.111 13.2519 21.0938 13.1943 21.0554 13.15C21.017 13.1064 20.9615 13.0812 20.9039 13.0812H17.7189L17.7183 11.323C17.7176 11.3144 17.6462 10.4664 18.0887 9.98156C18.2944 9.756 18.5755 9.64685 18.9473 9.64685H21.0098C21.1209 9.64685 21.2115 9.5569 21.2115 9.44511V6.30642C21.2095 6.19728 21.1222 6.10733 21.0124 6.10468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f71bfc7c0b94be048cf6112f20c0de2f.svg";
export { ForwardRef as ReactComponent };